import React from "react";
import { Layout } from "../layout";
import { useModule } from "./hooks";
import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
  Typography,
  Checkbox,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { MultiLineText, CheckboxWithLabel } from "~/components";

export const AdminSpecialist: React.VFC = () => {
  const classes = useStyles();

  const {
    states: {
      isSpecialistInit,
      specialists,
      columns,
      filterState,
      openDialog,
      selected,
      page,
      rowsPerPage,
    },
    setters: {
      handleChangeFilterState,
      handleCloseDialog,
      handleOpenDialog,
      handleChangePage,
      handleChangeRowsPerPage,
    },
    actions: { isSelected, handleClick, updatePublicInfo },
  } = useModule();

  return (
    <Layout loading={!isSpecialistInit}>
      <Paper className={classes.root}>
        <Toolbar className={classes.root}>
          <Typography className={classes.title} variant="h6" component="div">
            専門家一覧
          </Typography>
          <div className={classes.checkboxs}>
            <CheckboxWithLabel
              checked={filterState.public}
              label="公開"
              name="public"
              onChange={handleChangeFilterState}
            />
            <CheckboxWithLabel
              checked={filterState.private}
              label="非公開"
              name="private"
              onChange={handleChangeFilterState}
            />
            <Button
              className={classes.openDialogBtn}
              variant="contained"
              color="secondary"
              onClick={handleOpenDialog}
              disabled={selected.length === 0}
            >
              {`公開設定を更新(${selected.length})`}
            </Button>
          </div>
        </Toolbar>
        <TableContainer className={classes.container}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell />
                {columns.map((column, index) => (
                  <TableCell
                    key={`specialist_${column.id}_${index}`}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {specialists.length > 0 &&
                specialists
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const isItemSelected = isSelected(row.uid);
                    return (
                      <TableRow
                        hover
                        key={`specialist_${index}`}
                        className={classes.row}
                        onClick={() => handleClick(row.uid)}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={isItemSelected}
                            onChange={() => handleClick(row.uid)}
                          />
                        </TableCell>
                        {columns.map((column, index2) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={`specialist_${column.id}_${index2}`}
                            >
                              <MultiLineText>
                                {column.format ? column.format(value) : value}
                              </MultiLineText>
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              {specialists.length === 0 && (
                <TableRow hover>
                  <TableCell />
                  <TableCell colSpan={columns.length} align="left">
                    検索条件に一致する専門家データが存在しません
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={specialists.length}
          labelRowsPerPage="表示数:"
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>以下の専門家の公開設定を変更します</DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <ul>
              {selected
                .filter((item) => item.isPublic === true)
                .map((specialist) => {
                  const name = `${specialist.lastName} ${specialist.firstName}`;
                  return (
                    <li key={specialist.uid}>
                      {name}
                      <span className={classes.dialogSubText}>
                        {"（公開 -> 非公開）"}
                      </span>
                    </li>
                  );
                })}
              {selected
                .filter((item) => item.isPublic !== true)
                .map((specialist) => {
                  const name = `${specialist.lastName} ${specialist.firstName}`;
                  return (
                    <li key={specialist.uid}>
                      {name}
                      <span className={classes.dialogSubText}>
                        {"（非公開 -> 公開）"}
                      </span>
                    </li>
                  );
                })}
            </ul>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} variant="contained">
              キャンセル
            </Button>
            <Button
              onClick={updatePublicInfo}
              color="secondary"
              variant="contained"
            >
              更新する
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </Layout>
  );
};

const useStyles = makeStyles({
  root: {
    width: "100%",
    padding: 0,
    marginTop: 30,
  },
  container: {
    maxHeight: 500,
  },
  row: {
    cursor: "pointer",
  },
  checkboxs: {
    display: "flex",
    marginRight: 30,
  },
  title: {
    textAlign: "left",
    marginLeft: 20,
    flex: "1 1 100%",
  },
  openDialogBtn: {
    marginLeft: 20,
    width: 170,
  },
  dialogContent: {
    padding: 0,
    marginBottom: 20,
  },
  dialogSubText: {
    color: "#808080",
  },
});
